import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { DoctorDetailsForm } from './doctors-details-form';

import { BrandSelectData, DoctorData, doctorDataSchema } from '@shared/types';
import { ViewEditDialog } from '@web/components/ui/view-edit-dialog';

type DoctorDetailsCardProps = {
  doctor: DoctorData;
  brandsList: BrandSelectData[];
  onSubmit: (data: DoctorData) => Promise<void>;
  onClose?: () => void;
  defaultEditMode?: boolean;
  newEntityCreation?: boolean;
};

export function DoctorDetailsCard({
  doctor,
  brandsList,
  onSubmit,
  onClose,
  defaultEditMode = false,
  newEntityCreation = false,
}: DoctorDetailsCardProps) {
  const form = useForm<DoctorData>({
    resolver: zodResolver(doctorDataSchema),

    defaultValues: doctor,
  });

  return (
    <ViewEditDialog
      title="Doctor Details"
      onSubmit={async () => {
        await form.trigger();
        await form.handleSubmit(onSubmit, (errors) => {
          throw Error(`invalid contact info ${JSON.stringify(errors)}`);
        })();
      }}
      onClose={onClose}
      initEditMode={defaultEditMode}
      newEntityCreation={newEntityCreation}
      render={({ isEditMode, setIsSubmitting }) => (
        <DoctorDetailsForm
          form={form}
          isEditMode={isEditMode}
          setIsSubmitting={setIsSubmitting}
          brandsList={brandsList}
          onSubmit={async (data) => {
            await onSubmit(data);
            onClose?.();
          }}
        />
      )}
    />
  );
}
